export enum PassportActionType {
  ACCEPT = "accept",
  REJECT = "reject",
}

export enum PassportRuleType {
  HOST_HOST = "host_host",
  USER_HOST = "user_host",
}

export enum PassportProtocolType {
  DNS = "DNS",
  FTP = "FTP",
  HTTP = "HTTP",
  HTTPS = "HTTPS",
  IMAP = "IMAP",
  IMAPS = "IMAPS",
  MySQL = "MySQL",
  POP3 = "POP3",
  POP3S = "POP3S",
  RDP = "RDP",
  SMB = "SMB",
  SMTP = "SMTP",
  SSH = "SSH",
  TELNET = "TELNET",
  CUSTOM = "",
}

export enum PassportSourceDestinationHostType {
  HOST = "host",
  TAG = "tag",
}

export enum PassportSourceDestinationUserType {
  USER = "user",
  DEPARTMENT = "department",
}

/**
 * Maps protocol types to their default port numbers
 */
export const ProtocolToDefaultPort: Record<PassportProtocolType, string> = {
  [PassportProtocolType.DNS]: "53",
  [PassportProtocolType.FTP]: "21",
  [PassportProtocolType.HTTP]: "80",
  [PassportProtocolType.HTTPS]: "443",
  [PassportProtocolType.IMAP]: "143",
  [PassportProtocolType.IMAPS]: "993",
  [PassportProtocolType.MySQL]: "3306",
  [PassportProtocolType.POP3]: "110",
  [PassportProtocolType.POP3S]: "995",
  [PassportProtocolType.RDP]: "3389",
  [PassportProtocolType.SMB]: "445",
  [PassportProtocolType.SMTP]: "25",
  [PassportProtocolType.SSH]: "22",
  [PassportProtocolType.TELNET]: "23",
  [PassportProtocolType.CUSTOM]: "",
};

export enum PassportPeriodType {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}
